import React from 'react'
import { motion } from 'framer-motion';
import Navbar from '../../components/common/Navabar'
import serviceImage from "../../asserst/websiteImage/serviceImage.png"
import FAQ from "../../asserst/websiteImage/FAQ.png"
import Footer from '../../components/common/Footer';
import discover from "../../asserst/websiteImage/discover.png"
import delivery from "../../asserst/websiteImage/dilivery.png"
import destination from "../../asserst/websiteImage/destination.png"
import rental from "../../asserst/websiteImage/rental.png"
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import serviceRequest from "../../asserst/websiteImage/serviceRequest.png"
import mission from "../../asserst/websiteImage/mission.jpg";
import vision from "../../asserst/websiteImage/vision.jpg";
import safeRide from "../../asserst/websiteImage/safeRide.jpg";


const teamMembers = [
  {
    name: "Samed Khan",
    role: "CEO",
    imgSrc: "https://images.pexels.com/photos/428364/pexels-photo-428364.jpeg?auto=compress&cs=tinysrgb&w=150"
  },
  {
    name: "James Shams",
    role: "Vice President",
    imgSrc: "https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&w=150"
  },
  {
    name: "Abdur Razzak",
    role: "Designer",
    imgSrc: "https://images.pexels.com/photos/2379004/pexels-photo-2379004.jpeg?auto=compress&cs=tinysrgb&w=150"
  },
  {
    name: "Rodrigo Zaknal",
    role: "Developer",
    imgSrc: "https://images.pexels.com/photos/3748221/pexels-photo-3748221.jpeg?auto=compress&cs=tinysrgb&w=150"
  },
];
const features = [
  {
    title: 'Customer-Centric Approach',
    description: 'At Qbus, we put our customers first. Our team is committed to making each rental experience enjoyable and worry-free. From booking to journey’s end, we ensure your satisfaction and comfort.',
    iconUrl: 'asserst/images/customers.jpeg',
  },
  {
    title: 'Competitive Pricing',
    description: 'We believe that quality service should be affordable. With transparent pricing and no hidden fees, we ensure the best value for your money, making Qbus an attractive choice for all budgets.',
    iconUrl: '/asserst/images/comptitive-pricing.jpeg',
  },
  {
    title: 'Reliable Support',
    description: 'Our customer support team is available to assist every step of the way, whether you need help with booking, have questions, or require roadside assistance. We’re here for you, 24/7.',
    iconUrl: '/asserst/images/support.jpeg',
  },
];


const AboutPage = () => {

  const services = [
    {
      id: 1,
      title: "Diverse Vehicle Fleet",
      description:
        "Qbus offers a diverse fleet, including compact cars, luxury vehicles, taxis, and spacious buses for quick trips and events.",
      image: discover,
    },
    {
      id: 2,
      title: "Flexible Rental Options",
      description:
        "Choose from flexible rental plans—hourly, daily, weekly, or long-term—with customizable pickup/drop-off locations.",
      image: delivery,
    },
    {
      id: 3,
      title: "Easy Booking Process",
      description:
        "Booking with Qbus is easy! Use our online platform or mobile app to browse our fleet, check availability.",
      image: destination,
    },
  ];

  return (
    <div className="bg-white">
      <Navbar />
      <motion.section
        className="relative h-[30vh] rounded-b-[30px] "
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >

        <img src={serviceImage} className="h-full w-full object-cover rounded-b-[30px]" alt="Main Bus" />

        {/* Overlay container */}
        <div className="absolute inset-0 bg-[#0739564D] flex rounded-b-[30px] items-center justify-center">
        </div>
        <div className="absolute -bottom-24  flex-col md:w-[25rem] xsm:w-[15rem] md:h-[12rem] xsm:h-[8rem] rounded-xl shadow-lg border-blue-600 border-[2px] left-1/2 transform -translate-x-1/2  bg-white flex text-center items-center justify-center"
          style={{ boxShadow: "10px 10px 30px 0px #0000001A" }}
        >
          <div className='w-full '>
            <motion.h2
              className="font-bold text-gray-800 mb-5 md:text-[50.8px] xsm:text-[2.5rem] w-[100%] leading-[47px]  underline-offset-[from-font] decoration-none"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              Abouts
            </motion.h2>
            <motion.p
              className="text-gray-500 font-poppins text-base w-[100%] font-normal leading-6  underline-offset-[from-font] decoration-none"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.4 }}
            >
              Home/About
            </motion.p>
          </div>
        </div>
      </motion.section>

      <section className='w-[100%] flex mx-auto  xsm:mt-20'>
        <div className=' xsm:p-2 md:p-8 xsm:w-[100%]  md:w-[80%] mx-auto font-poppins text-gray-800 mt-10 pt-20 text-start'>
          <p className="text-orange-400 underline underline-offset-1 font-semibold">About us</p>

          {/* Who We Are Section */}
          <div className='grid grid-cols-1  md:grid-cols-2 gap-8 items-center mt-10'>
            <div className=' md:p-4  xsm:p-2 space-y-4 '>
              <h2 className='text-xl font-semibold '>What do we provides?</h2>
              <motion.p
                className='text-gray-500 text-base font-normal leading-6'
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
              >
                Qbus Rentals is a provider of convenient and reliable online taxi booking services. We specialize in offering a seamless transportation experience, connecting customers with professional
                drivers through our user-friendly platform. Whether you need a quick ride across town, airport transfers, or outstation travel, Qbus Rentals ensures comfort, safety, and affordability. Our diverse fleet of vehicles caters to both individual and group travel needs. With 24/7 availability, transparent pricing, and excellent customer support, Qbus Rentals is your go-to solution for hassle-free travel. Experience the future of transportation with Qbus Rentals, where every journey is just a click away.
              </motion.p>
            </div>
            <div className='flex justify-center'>
              <img src={safeRide} alt="Who We Are" 
                className="h-72 w-full object-center object-contain rounded-md"/>
                 </div>
          </div>

          {/* Our Mission Section */}
          <div className='grid grid-cols-1 md:grid-cols-2  gap-8  mt-12'>
            <div className='flex justify-center'>
              <img src={mission} alt="Our Mission"
               className="h-72 w-full object-center object-contain rounded-md"/>
               </div>
            <div className='xsm:p-2 md:p-4 space-y-4'>
              <h2 className='text-xl font-semibold '>Our Mission</h2>
              <motion.p
                className='text-gray-500 text-base font-normal leading-6'
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
              >
                At Qbus, our mission is to make transportation accessible, comfortable, and affordable for all. We are dedicated to creating a seamless rental experience by continually expanding our fleet, refining our services, and listening to the feedback of those we serve.
              </motion.p>
            </div>
          </div>

          {/* Our Vision Section */}
          <div className='grid grid-cols-1 md:grid-cols-2 gap-8  mt-12'>
            <div className='xsm:p-2 md:p-4  space-y-4'>
              <h2 className='text-xl font-semibold '>Our Vision</h2>
              <motion.p
                className='text-gray-500 text-base font-normal leading-6'
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
              >
                We aim to become the go-to choice for vehicle rentals, recognized for our commitment to quality, innovation, and exceptional customer experience. By adapting to changing travel needs and advancing sustainable practices, we strive to set new standards in the industry.
              </motion.p>
            </div>
            <div className='flex justify-center'>
              <img src={vision} alt="Our Vision"  className="h-72 w-full object-center object-contain rounded-md"/>
               
            </div>
          </div>
        </div>
      </section>
      <section className="w-[100%] xsm:h-auto md:h-[600px] bg-orange-50 py-20">
        <div className="w-[70%] mx-auto text-center">
          <p className="text-orange-400 underline underline-offset-1 font-semibold">
            Services
          </p>
          <motion.h2
            className="font-bold text-gray-800 md:mb-5 xsm:text-[1.3rem] md:text-[1.8rem] w-[100%] xsm:my-5 md:leading-[40px] text-center underline-offset-[from-font] decoration-none"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            From Booking to Drop-Off,
            <br />
            We’ve Got You Covered
          </motion.h2>

          <div className="grid xsm:grid-cols-1 md:grid-cols-3 gap-2 xsm:space-y-2">
            {services.map((service) => (
              <div
                key={service.id}
                className="bg-[#fff] space-y-4 col-span-1 w-[18rem] h-[18rem] p-4 rounded-md shadow-md"
              >
                <div className="w-full flex items-end justify-center">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="h-[50px] w-[50px]"
                  />
                </div>
                <p className="font-semibold text-center font-poppins text-gray-800">
                  {service.title}
                </p>
                <motion.p
                  className="text-gray-500 font-poppins text-base w-[100%] font-normal leading-6 underline-offset-[from-font] decoration-none"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.4 }}
                >
                  {service.description}
                </motion.p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className='w-full   items-center bg--50 flex flex-col mb-16'>
        <h5 className="text-orange-400 underline   underline-offset-1 font-semibold text-center w-[70%] mt-5 mx-auto mb-16">Why Choose Us?</h5>
        <div className="w-[70%] mx-auto ">
          {/* <h2 className="text-3xl font-bold text-center text-gray-800 mb-8">Why Choose Us?</h2> */}


          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {features.map((feature, index) => (
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.2, type: "spring", stiffness: 300 }}
                key={index}
                className="bg-white rounded-lg h-[300px] xsm:px-4 md:p-2 cursor-pointer shadow-lg flex flex-col items-center text-center"
                whileHover={{
                  scale: 1.05,
                  boxShadow: "0px 8px 15px rgba(0, 0, 0, 0.2)"
                }}
              >
                {/* Icon */}
                <img src={feature.iconUrl} alt={`${feature.title} Icon`} className="h-16 w-16 mb-4" />

                {/* Title */}
                <h3 className="text-[14px] font-semibold text-gray-800">{feature.title}</h3>

                {/* Description */}
                <motion.p
                  className="text-gray-500 text-base font-normal leading-6"
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5 }}
                >
                  {feature.description}
                </motion.p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
      <motion.section
        className="relative h-[15vh] md:h-[30vh] lg:h-[20vh]"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <img src={serviceRequest} className="h-full w-full object-cover" alt="Main Bus" />
        <div className="absolute inset-0 bg-[#02050e80] flex  items-center justify-center text-center space-y-2 p-4">
          <div className='w-[100%] mx-auto flex place-content-center'>
            <div className='w-[60%]'>
              <h2 className="text-white font-bold xsm:text-[1.2rem] md:text-3xl lg:text-4xl">
                Are you looking for a Transport Service?
              </h2>
              <p className="text-white xsm:text-[0.7rem] md:text-base lg:text-lg">
                We always help you to transport your products and documents
              </p>
            </div>
            <button className="mt-4 xsm:py-1 xsm:px-3 md:px-6 py-2 bg-white text-blue-700 font-semibold rounded-lg hover:bg-gray-200 transition">
              Send Request
            </button>
          </div>
        </div>
      </motion.section>
      <div className='bg-[#0B0757] pb-10'>
        <Footer />
      </div>
    </div >
  )
}
export default AboutPage